module.exports = {
	pre:"XSEED_",
	// defaultExpiration:99999	//天数
}


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 0
// module chunks = 0